import { PAGE_TYPE_ACTIVITY, PAGE_TYPE_PROPERTY } from 'constants/index';

import axios from './axios';
import createOption from './createOption';
import { getTagsString } from './tags';

export function fetchCountries() {
  return axios
    .get('/countries')
    .then(({ data }) => data.data.map((item: { id: number; name: string }) => createOption(item)));
}

const PAGE_TYPE_TO_CATALOG_NAME_MAP = {
  [PAGE_TYPE_PROPERTY]: 'properties',
  [PAGE_TYPE_ACTIVITY]: 'activities',
};

export interface IFetchAreas {
  accId: string;
  countryId: number;
  targetId: number;
  isAgent: boolean;
  pageType: string;
}

export interface IDataItem {
  account: IAccount;
  country: ICountry;
  creator: ICreator;
  handle: string;
  id: number;
  name: string;
  pageCurrentStep: string;
  pageId: number;
  pageStatus: string;
  systemWide: boolean;
  shared?: boolean;
  tags?: string[];
}

export interface IAccount {
  id: string;
  type: string;
}

export interface ICountry {
  id: number;
  name: string;
}

export interface ICreator {
  email: string;
  fullName: string;
  id: number;
  status: boolean;
}

export function fetchAreas({ accId, countryId, targetId, isAgent, pageType }: IFetchAreas, reqParams: any = {}) {
  const path = targetId
    ? //@ts-ignore
      `acc/${accId}/${PAGE_TYPE_TO_CATALOG_NAME_MAP[pageType]}/${targetId}/areas?country_id=${countryId}`
    : `acc/${accId}/areas?country_id=${countryId}`;

  return axios.get(path, reqParams).then(({ data = {} }) => {
    const arr = data?.data || [];
    return arr.map((item: IDataItem) => {
      return {
        label: item.name ?? item.handle,
        value: item.id,
        pageId: item?.pageId,
        pageCurrentStep: item?.pageCurrentStep,
        optionActionAvailable: item.pageCurrentStep === 'page',
        pageStatus: item?.pageStatus,
        name: item?.name,
        showContentIndicator: isAgent && (item.systemWide || item?.shared),
        shared: item?.shared,
        tagsString: getTagsString(item.tags),
      };
    });
  });
}
export function fetchPortfolios() {
  return axios.get('/portfolios').then(({ data = [] }) =>
    data?.map((p: string) => {
      return { label: p, value: p };
    }),
  );
}
